import { executeQuery } from 'firebase/data-connect';
import { getChatReadRef, getUnreadChatCountRef } from '../dataconnect-generated';
import { getChatDataConnect } from './dataConnect';

const INITIAL_CHAT_READ_AT = '1970-01-01T00:00:00.000Z';

interface GetUnreadChatCountParams {
  nursingHomeId: number;
  userUuid: string;
}

export const getUnreadChatCount = async ({
  nursingHomeId,
  userUuid,
}: GetUnreadChatCountParams): Promise<number> => {
  const reads = await executeQuery(
    getChatReadRef(getChatDataConnect(), {
      nursingHomeId,
      userUuid,
    }),
  );
  const lastReadAt = reads.data.chatReads[0]?.lastReadAt ?? INITIAL_CHAT_READ_AT;
  const unreadMessages = await executeQuery(
    getUnreadChatCountRef(getChatDataConnect(), {
      nursingHomeId,
      userUuid,
      lastReadAt,
    }),
  );

  return unreadMessages.data.chats.length;
};
